export default __webpack_public_path__ + "static/Brochure Ezy-Medical ENG-95a91a371f2c2bc29aeaa0059b33b6ee.pdf";